/** * メッセージコンポーネント */
<template>
  <b-container id="the-message" class="container-message">
    <div class="content-navbar">
      <!-- メッセージタイプ -->
      <div class="message-nav">
        <b-button-group size="lg">
          <!-- 受信一覧選択ボタン -->
          <b-button
            size="sm"
            v-bind:variant="isMessageTypeReceived ? 'success' : 'secondary'"
            v-bind:pressed="isMessageTypeReceived"
            v-on:click="$_onClickMessageType(MESSAGE_TYPES.RECEIVE)"
          >
            {{ $t('theMessage.receivedList') }}
          </b-button>
          <!-- 送信一覧選択ボタン -->
          <b-button
            size="sm"
            v-bind:variant="isMessageTypeSend ? 'success' : 'secondary'"
            v-bind:pressed="isMessageTypeSend"
            v-on:click="$_onClickMessageType(MESSAGE_TYPES.SEND)"
          >
            {{ $t('theMessage.sendList') }}
          </b-button>
        </b-button-group>
      </div>
      <!-- 検索ツールバー -->
      <div class="tool-bar">
        <b-form-row class="tool-bar-form">
          <!-- ユーザー選択(送信者/受信者) -->
          <b-col>
            <!-- (受信メッセージ検索用)送信者選択 -->
            <user-selector
              v-if="isMessageTypeReceived"
              all-organizations
              v-bind:primary-organization-id="
                $store.getters['userProfile/defaultOrganizationId']
              "
              v-bind:default-text="$t('theMessage.allSentUser')"
              v-bind:keyword-target="
                $store.getters['userKeywordTarget/keywordTargets']
              "
              v-bind:indoor-sites="$store.getters['indoorSite/indoorSites']"
              v-bind:on-api-error="handleApiError"
              v-bind:value="sendUserValue"
              v-bind:targetUserType="'app'"
              v-on:change:value="$_onSelectedSendUsers"
              v-on:change:keywordTarget="
                $store.dispatch('userKeywordTarget/setKeywordTargets', $event)
              "
            />
            <!-- (送信メッセージ検索用)宛先選択 -->
            <user-selector
              v-else-if="isMessageTypeSend"
              all-organizations
              v-bind:primary-organization-id="
                $store.getters['userProfile/defaultOrganizationId']
              "
              v-bind:default-text="$t('theMessage.allReceivedUser')"
              v-bind:keyword-target="
                $store.getters['userKeywordTarget/keywordTargets']
              "
              v-bind:indoor-sites="$store.getters['indoorSite/indoorSites']"
              v-bind:on-api-error="handleApiError"
              v-bind:value="receivedUserValue"
              v-on:change:value="$_onSelectedReceivedUsers"
              v-on:change:keywordTarget="
                $store.dispatch('userKeywordTarget/setKeywordTargets', $event)
              "
            />
          </b-col>
          <!-- キーワード検索 -->
          <b-col>
            <input-keyword
              v-model="searchKeyword"
              v-bind:placeholder="$t('theMessage.placeholder.searchKeyword')"
              v-on:search="$_onSearchKeyword"
            />
          </b-col>
          <!-- 検索項目が追加されたらcolsを調整してください -->
          <b-col cols="5" />
        </b-form-row>
      </div>
    </div>
    <b-row no-gutters class="content-wrapper">
      <!-- メッセージ一覧 -->
      <b-col cols="6" class="view-list">
        <!-- タイトルバー -->
        <b-row class="title-bar">
          <b-col class="title-bar-list title-bar-between">
            <!-- メッセージタイトル -->
            <h1 v-t="'theMessage.message_'" />
            <div class="title-bar-action">
              <!-- 更新 -->
              <div v-show="isMessageTypeReceived" class="title-bar-reload">
                <p class="label">
                  {{ $t('theMessage.listUpdate.field') }} :
                  {{ receivedMessageUpdateDateLabel }}
                </p>
                <button-reload v-on:click="$_updateReceivedMessages" />
              </div>
              <!-- 作成ボタン -->
              <b-button
                variant="light"
                v-ifield-b-tooltip.hover
                v-bind:title="$t('theMessage.action.createNewMessage')"
                class="button-create"
                v-on:click="$_showMessagePost"
              >
                <icon-message class="icon" />
                <span v-t="'theMessage.action.create'" />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <div class="list-wrapper">
          <loading-mask v-bind:isLoading="isLoading">
            <!-- 一覧のツールバー -->
            <div class="list-header" v-show="isMessageTypeReceived">
              <!-- 全て表示/未読のみ 検索ボタン-->
              <filter-button-group
                v-model="currentReadType"
                v-bind:buttons="messageReadFilterButtons"
                v-bind:label="$t('theMessage.display')"
              />
            </div>
            <!-- 一覧 -->
            <div
              ref="list-inner"
              class="list-inner"
              v-bind:class="{
                'list-inner-receive': isMessageTypeReceived,
                'list-inner-send': isMessageTypeSend,
              }"
            >
              <!-- 受信メッセージ -->
              <template v-if="isMessageTypeReceived">
                <div
                  v-for="message in receivedMessagesForCard"
                  v-bind:key="message.id"
                >
                  <div class="event-card">
                    <card-message
                      v-bind:base-date="baseDate"
                      v-bind="message"
                      v-on:messagecard-click="$_onClickMessageCardReceive"
                    />
                  </div>
                </div>
              </template>
              <!-- 送信メッセージ -->
              <template v-if="isMessageTypeSend">
                <div
                  v-for="message in sentMessagesForCard"
                  v-bind:key="message.id"
                >
                  <div class="event-card">
                    <card-message
                      message-type="send"
                      v-bind:base-date="baseDate"
                      v-bind="message"
                      v-on:messagecard-click="$_onClickMessageCardSend"
                    />
                  </div>
                </div>
              </template>
              <div v-show="existsMorePastMessage" class="list-tail">
                <!-- 次のメッセージ取得 -->
                <b-button
                  variant="light"
                  size="sm"
                  v-on:click="$_showMoreMessages"
                >
                  {{ $t('theMessage.message.getNext', { limit: limit }) }}
                </b-button>
              </div>
            </div>
          </loading-mask>
        </div>
      </b-col>
      <!-- メッセージ詳細 -->
      <b-col cols="6" class="view-detail">
        <!-- メッセージ本体 -->
        <div class="message-detail-body">
          <!-- 受信メッセージ -->
          <message-detail
            key="receive-detail"
            v-if="isMessageTypeReceived"
            ref="receive-message-detail"
            message-type="receive"
            component-prefix="receive"
          />
          <!-- 送信済みメッセージ -->
          <message-detail
            key="send-detail"
            v-if="isMessageTypeSend"
            ref="send-message-detail"
            message-type="send"
            component-prefix="send"
          />
        </div>
      </b-col>
    </b-row>
    <!-- 新規メッセージ送信ダイアログ -->
    <message-post-dialog
      ref="message-post-dialog"
      v-on:message-post-end="$_onSendNewMessage"
    />
  </b-container>
</template>

<script>
import { inject } from 'vue'
import { mapGetters } from 'vuex'
import ButtonReload from '@/components/AppButtonReload.vue'
import IconMessage from '@/assets/ifield/ic_message.svg?component'
import FilterButtonGroup from '@/components/AppFilterButtonGroup.vue'
import CardMessage from '@/components/message/AppCardMessage.vue'
import MessagePostDialog from '@/components/message/AppMessagePostDialog.vue'
import MessageDetail from '@/components/message/AppMessageDetail.vue'
import { RestApiClient } from 'ifield-core-components'
import { toLocalTz, toServerTz } from '@/js/TimezoneHelper'
import {
  MAX_SAFE_INTERVAL_DELAY,
  DATE_FORMAT_HYPHEN,
  TIME_FORMAT_MILLISECOND,
} from '@/constants.js'
import { useHandleApiError } from '@/composables/UseHandleApiError.js'

import moment from 'moment'

/**
 * 検索対象の受信メッセージ状態
 */
const MESSAGE_READ_TYPES = {
  ALL: 'all',
  UNREAD: 'unread',
}

/**
 * メッセージタイプ
 */
const MESSAGE_TYPES = {
  RECEIVE: 'received',
  SEND: 'send',
}

/**
 * ミリ秒日時フォーマット
 */
const DATETIME_FORMAT_MILLISECOND = `${DATE_FORMAT_HYPHEN}T${TIME_FORMAT_MILLISECOND}`

/**
 * AppUserSelector の選択値をユニークなユーザーIDの配列に変換する
 * @param {Object[]} value AppUserSelector の選択値
 * @returns {number[]} ユニークなユーザーID配列
 */
const toUniqueUserIds = (value) => {
  if (!value) return []
  const ids = []
  for (const { type, id, users } of value) {
    if (type === 'user') {
      ids.push(id)
    } else if (type === 'organization') {
      ids.push(...users.map((u) => u.id))
    }
  }
  return [...new Set(ids)]
}

/**
 * 宛先ユーザーのユーザー名を表示用に変換する
 * 複数の場合は `${先頭のユーザー名} + n` 表記になる
 * @param {Object[]} users 宛先ユーザー
 * @returns {string} 表示用ユーザー名
 */
const toDisplayReceivedUserName = (users) => {
  if (!users) {
    return ''
  }
  let userName = users[0].receive_user_name
  // 宛先が複数の場合はユーザー名の後に"+n"を追加する
  if (users.length > 1) {
    userName += ` +${users.length - 1}`
  }
  return userName
}

export default {
  name: 'TheMessage',
  components: {
    'button-reload': ButtonReload,
    'icon-message': IconMessage,
    'filter-button-group': FilterButtonGroup,
    'card-message': CardMessage,
    'message-post-dialog': MessagePostDialog,
    'message-detail': MessageDetail,
  },
  props: {
    /**
     * 1回の読み込みメッセージ件数
     */
    limit: {
      type: Number,
      default: 10,
      require: false,
    },
  },
  setup(props, context) {
    const baseDate = inject('baseDate')
    const { handleApiError } = useHandleApiError(props, context)
    return { baseDate, handleApiError }
  },
  data: function () {
    return {
      /**
       * 新着メッセージ定期チェックのIntervalID
       * @type {number}
       */
      checkIntervalId: null,
      /**
       * 現在選択中のメッセージタイプ
       * @type {String}
       */
      currentMessageType: MESSAGE_TYPES.RECEIVE,
      /**
       * 送信メッセージ一覧
       * @type {Array}
       */
      sentMessages: [],
      /**
       * 受信メッセージ一覧
       * @type {Array}
       */
      receivedMessages: [],
      /**
       * 受信メッセージ一覧の最終更新日時
       */
      receivedMessageUpdateDate: null,
      /**
       * メッセージ詳細
       * @type {MessageDetail}
       */
      messageDetail: null,
      /**
       * 選択中の送信者選択値
       * @type {Object}
       */
      sendUserValue: null,
      /**
       * 選択中の送信者選択値
       * @type {Object}
       */
      receivedUserValue: null,
      /**
       * 検索キーワード
       * @type {string}
       */
      searchKeyword: null,
      /**
       * 比較用検索キーワード
       * @type {string}
       */
      previousKeyword: '',
      /**
       * 現在選択している検索対象のメッセージ既読状態(受信メッセージ検索用)
       */
      currentReadType: MESSAGE_READ_TYPES.ALL,
      /**
       * 新着受信メッセージの件数
       * @type {number}
       */
      newMessageCount: 0,
      /**
       * 更に過去のメッセージが存在する場合はtrue
       */
      existsMorePastMessage: true,
      /**
       * メッセージを取得する際の基準日時(受信メッセージ用)
       * @type {number}
       */
      receivedMessageBaseDate: null,
      /**
       * 基準日時より過去の取得済みのメッセージ件数(受信メッセージ用)
       * @type {number}
       */
      pastMessagesCount: 0,
      /**
       * メッセージを取得する際の基準日時(送信メッセージ用)
       * @type {number}
       */
      sentMessageBaseDate: null,
      /**
       * ロード中の場合はtrue
       * @type {Boolean}
       */
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters('user', ['userMap']),
    /**
     * 受信メッセージ一覧の更新頻度(ms)
     */
    interval: function () {
      const interval = this.$store.state.receiveMessage.updateInterval * 1000
      return interval > MAX_SAFE_INTERVAL_DELAY
        ? MAX_SAFE_INTERVAL_DELAY
        : interval
    },
    /**
     * 検索対象の受信メッセージ種別(定数)
     * @type {Object}
     */
    MESSAGE_TYPES: function () {
      return MESSAGE_TYPES
    },
    /**
     * 検索対象の受信メッセージ状態種別(定数)
     * @type {Object}
     */
    MESSAGE_READ_TYPES: function () {
      return MESSAGE_READ_TYPES
    },
    /**
     * 受信メッセージ状態ボタン
     * @type {Array.<Object>}
     */
    messageReadFilterButtons: function () {
      return [
        {
          value: MESSAGE_READ_TYPES.ALL,
          text: this.$t('theMessage.filter.all'),
        },
        {
          value: MESSAGE_READ_TYPES.UNREAD,
          text: this.$t('theMessage.filter.onlyUnread'),
        },
      ]
    },
    /**
     * 現在選択している検索対象の受信メッセージ状態種別が「すべて」の場合にtrueを返却する
     * @type {boolean}
     */
    isReadTypeAll: function () {
      return this.currentReadType === MESSAGE_READ_TYPES.ALL
    },
    /**
     * 現在選択している検索対象の受信メッセージ状態種別が「未読」の場合にtrueを返却する
     * @type {boolean}
     */
    isReadTypeUnread: function () {
      return this.currentReadType === MESSAGE_READ_TYPES.UNREAD
    },
    /**
     * 受信メッセージ一覧の最終更新日の表示ラベル
     * @type {string}
     */
    receivedMessageUpdateDateLabel: function () {
      if (!this.receivedMessageUpdateDate) {
        return ''
      }
      return moment(this.receivedMessageUpdateDate).format(
        this.$t('theMessage.listUpdate.format')
      )
    },
    /**
     * 現在選択中のメッセージ種別が受信の場合はtrue
     * @return {boolean}
     */
    isMessageTypeReceived: function () {
      return this.currentMessageType === MESSAGE_TYPES.RECEIVE
    },
    /**
     * 現在選択中のメッセージ種別が送信の場合はtrue
     * @return {boolean}
     */
    isMessageTypeSend: function () {
      return this.currentMessageType === MESSAGE_TYPES.SEND
    },
    /**
     * 選択中の送信者ユーザーIDリスト(受信メッセージ検索用)
     * @type {number[]}
     */
    currentSendUserIds: function () {
      return toUniqueUserIds(this.sendUserValue)
    },
    /**
     * 選択中の受信者ユーザーIDリスト(送信メッセージ検索用)
     * @type {number[]}
     */
    currentReceivedUserIds: function () {
      return toUniqueUserIds(this.receivedUserValue)
    },
    /**
     * 受信メッセージ(カード用)
     * @type {Object[]}
     */
    receivedMessagesForCard: function () {
      return this.receivedMessages.map((m) => ({
        id: m.id,
        content: m.content,
        scheduleTitle: m.schedule_title,
        isRead: m.read_flg,
        attachFilesCount: m.attach_file_num,
        sendUserId: m.send_user_id,
        sendUserName: m.send_user_name,
        sendUserProfileAttachFileType:
          m.send_user_profile_image?.attach_file_type || null,
        sendAt: m.send_at,
        groups: this.userMap.get(m.send_user_id)?.groups || [],
      }))
    },
    /**
     * 送信メッセージ(カード用)
     * @type {Object[]}
     */
    sentMessagesForCard: function () {
      return this.sentMessages.map((m) => {
        const primaryReceiveUserId = m.receive_users[0].receive_user_id
        return {
          id: m.id,
          content: m.content,
          scheduleTitle: m.schedule_title,
          attachFilesCount: m.attach_file_num,
          sendUserId: primaryReceiveUserId,
          sendUserName: toDisplayReceivedUserName(m.receive_users),
          sendUserProfileAttachFileType:
            m.send_user_profile_image?.attach_file_type || null,
          sendAt: m.send_at,
          groups: this.userMap.get(primaryReceiveUserId)?.groups || [],
        }
      })
    },
    /**
     * キーワードが変更された場合はtrue
     * @type {Boolean}
     */
    isKeywordChanged: function () {
      return this.searchKeyword != this.previousKeyword
    },
    /**
     * エラーコード
     * @type {Number}
     */
    errorCode: function () {
      return this.$store.state.error.code
    },
  },
  watch: {
    interval: function () {
      this.$_stopCheckNewReceivedMessages()
      this.$_startCheckNewReceivedMessages()
    },
    currentReadType: function () {
      this.$_searchMessageList()
    },
    errorCode: {
      immediate: true,
      handler: function (value) {
        if (value === 401) {
          this.$_stopCheckNewReceivedMessages()
        }
      },
    },
  },
  created: function () {
    this.$_updateUsers()
    this.$_updateIndoorSites()
  },
  mounted: function () {
    this.$_initMessage()
    // アプリのメッセージチェックを停止する
    this.$store.dispatch('disableAppMessageCheck')
  },
  beforeDestroy: function () {
    // インターバル処理を停止する
    this.$_stopCheckNewReceivedMessages()
    // アプリのメッセージチェックを再開する
    this.$store.dispatch('enableAppMessageCheck')
  },
  methods: {
    /**
     * ユーザーデータ更新
     */
    $_updateUsers: async function () {
      try {
        this.$store.dispatch('user/updateUsersWithThrottle')
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.info('failed to fetch users. use fetched before.')
        })
      }
    },

    /**
     * サイトデータ更新
     */
    $_updateIndoorSites: async function () {
      try {
        this.$store.dispatch('indoorSite/updateIndoorSitesWithThrottle')
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.info('failed to fetch indoor sites. use fetched before.')
        })
      }
    },

    /**
     * メッセージデータ初期化処理
     */
    $_initMessage: async function () {
      this.$_setMessageType(this.currentMessageType)
    },

    /**
     * メッセージ一覧を表示する
     * @param {String} レイヤ表示名称
     */
    $_searchMessageList: async function () {
      this.$_showLoading()

      if (this.currentMessageType === MESSAGE_TYPES.RECEIVE) {
        await this.$_searchReceivedMessageList()
      } else {
        await this.$_searchSentMessageList()
      }

      // 変更検知用に前回キーワードを保持
      this.previousKeyword = this.searchKeyword
      this.$_hideLoading()
    },

    /**
     * 受信メッセージを検索する
     */
    $_searchReceivedMessageList: async function () {
      const updateDate = new Date()
      this.pastMessagesCount = 0
      this.receivedMessages = []
      this.newMessageCount = 0

      // 基準日時より未来の送信日時のメッセージは新着メッセージとしてカウントする
      // メッセージ送信の遅延を考慮して現在時刻より少し前の時刻を基準日時に設定する
      // (送信側のネットワーク環境が悪かったり、サーバーに負荷がかかっている場合
      // 送信からサーバーが処理するまでに時間がかかる場合があるため)
      this.receivedMessageBaseDate = moment()
        .subtract(1500, 'milliseconds')
        .toDate()

      await this.$_showPastReceivedMessageList()

      // 更新日時を設定する
      this.receivedMessageUpdateDate = updateDate

      // 一覧のスクロールバーを先頭に戻す
      this.$refs['list-inner'].scrollTo(0, 0)
    },

    /**
     * 送信済みメッセージを検索する
     */
    $_searchSentMessageList: async function () {
      this.sentMessages = []
      this.sentMessageBaseDate = moment().toDate()

      await this.$_showSentMessageList()

      // 一覧のスクロールバーを先頭に戻す
      this.$refs['list-inner'].scrollTo(0, 0)
    },

    /**
     * 更に過去のメッセージを取得する
     */
    $_showMoreMessages: async function () {
      this.$_showLoading()
      if (this.currentMessageType === MESSAGE_TYPES.RECEIVE) {
        await this.$_showPastReceivedMessageList()
      } else {
        await this.$_showSentMessageList()
      }
      this.$_hideLoading()
    },

    /**
     * 受信メッセージ一覧を表示する(過去のメッセージを遡って取得する)
     */
    $_showPastReceivedMessageList: async function () {
      // offsetは、取得済みのメッセージ件数
      const offset = this.pastMessagesCount
      // limitは、更に過去のメッセージが存在するかどうかを判定するためにlimit+1件を取得する
      const limit = this.limit + 1

      let messages = await this.$_getPastReceivedMessageList(offset, limit)
      if (messages) {
        let newMessages = messages.slice(
          0,
          Math.min(this.limit, messages.length)
        )
        const beforeMessageCount = this.receivedMessages.length
        this.$_addReceivedMessages(newMessages)

        // 取得済みの受信メッセージ件数は、メッセージ一覧に追加前後の件数の差分
        // (重複して取得している可能性があるため)
        const afterMessageCount = this.receivedMessages.length
        this.pastMessagesCount += afterMessageCount - beforeMessageCount

        // 更に過去のメッセージが存在するかのチェック
        this.existsMorePastMessage = messages.length > this.limit
      }
    },

    /**
     * 受信メッセージ一覧を取得する（基準日時より過去のメッセージ）
     * @param {number} offset メッセージ一覧からの取得対象となるメッセージのoffset
     * @param {number} limit メッセージ一覧からの取得対象となるメッセージのlimit
     * @return {Array} メッセージ一覧、ただし取得時にエラーが発生した場合はnull
     */
    $_getPastReceivedMessageList: async function (offset, limit) {
      // URL作成
      let url = RestApiClient.createApiUrl('receive_message')
      let params = url.searchParams
      // 検索条件追加
      this.$_addSearchConditionForReceived(params)
      // 受信メッセージ状態種別
      if (this.currentReadType !== MESSAGE_READ_TYPES.ALL) {
        let readType = null
        if (this.currentReadType === MESSAGE_READ_TYPES.UNREAD) {
          readType = 0
        }
        params.append('read_flg', readType)
      }
      // before
      params.append(
        'before',
        toServerTz(
          this.receivedMessageBaseDate.getTime(),
          DATETIME_FORMAT_MILLISECOND
        )
      )
      // offset
      params.append('offset', offset)
      // limit
      params.append('limit', limit)

      let messages = null
      try {
        const json = await RestApiClient.executeGetApi(url)
        messages = json.data.map((d) => ({
          ...d,
          send_at: toLocalTz(d.send_at, DATETIME_FORMAT_MILLISECOND),
        }))
      } catch (error) {
        this.handleApiError(error)
        throw error
      }

      return messages
    },

    /**
     * 受信メッセージ一覧を表示する(基準日時より新しいメッセージを取得する)
     * @return {Array} メッセージ一覧、ただし取得時にエラーが発生した場合はnull
     */
    $_getNewReceivedMessageList: async function () {
      // URL作成
      let url = RestApiClient.createApiUrl('receive_message')
      let params = url.searchParams
      // 検索条件追加
      this.$_addSearchConditionForReceived(params)
      // after
      // * クライアント側の送信からサーバーが処理するまでに時間がかかったメッセージが存在する可能性もあるため、
      //   受信メッセージ一覧取得の基準日時より少し前から取得するようにする
      // * 何度も同じメッセージを受信してしまうので、this.receivedMessagesには重複しないように追加する
      // * 検索パラメータでサーバーの処理日時(レコード作成日など)を指定できれば何度も同じレコードを取得する必要はなくなると思われる
      const afterDate = moment(this.receivedMessageBaseDate).subtract(
        5,
        'second'
      )
      params.append(
        'after',
        toServerTz(+afterDate, DATETIME_FORMAT_MILLISECOND)
      )

      let messages = null
      try {
        let json = await RestApiClient.executeGetApi(url)
        messages = json.data.map((d) => ({
          ...d,
          send_at: toLocalTz(d.send_at, DATETIME_FORMAT_MILLISECOND),
        }))
      } catch (error) {
        this.handleApiError(error)
        throw error
      }

      return messages
    },

    /**
     * 送信メッセージ一覧を表示する
     */
    $_showSentMessageList: async function () {
      // URL作成
      let url = RestApiClient.createApiUrl('send_message')
      let params = url.searchParams
      // 検索条件追加
      this.$_addSearchConditionCommon(params)
      // 宛先ユーザーID
      if (this.currentReceivedUserIds.length > 0) {
        params.append('receive_user_id', this.currentReceivedUserIds)
      }
      // before
      params.append(
        'before',
        toServerTz(
          this.sentMessageBaseDate.getTime(),
          DATETIME_FORMAT_MILLISECOND
        )
      )
      // offset
      // 「更に10件取得する」に対応するため、取得済みのメッセージ件数をoffsetとする
      params.append('offset', this.sentMessages.length)
      // limit
      // 更に過去のメッセージがあるかをチェックするためにlimitより1件多く取得する
      params.append('limit', this.limit + 1)

      try {
        const json = await RestApiClient.executeGetApi(url)
        const messages = json.data.map((d) => ({
          ...d,
          send_at: toLocalTz(d.send_at, DATETIME_FORMAT_MILLISECOND),
        }))
        const newMessages = messages.slice(
          0,
          Math.min(this.limit, messages.length)
        )

        // 一覧を更新する
        // メッセージを送信してからサーバーが処理するまでに時間がかかった場合、
        // メッセージが重複してしまう可能性があるため重複チェックする
        newMessages.forEach((newMessage) => {
          let findIndex = this.sentMessages.findIndex(
            (sentMessage) => sentMessage.id === newMessage.id
          )
          if (findIndex < 0) {
            // 存在しない場合はリストの末尾に追加する
            this.sentMessages.push(newMessage)
          } else {
            // 存在する場合は更新する
            this.sentMessages.splice(findIndex, 1, newMessage)
          }
        })

        // 更に過去のメッセージが存在するかのチェック
        this.existsMorePastMessage = messages.length > this.limit
      } catch (error) {
        this.handleApiError(error)
      }
    },

    /**
     * 送信メッセージ一覧を表示する(基準日時より新しいメッセージを取得する)
     * @return {Array} メッセージ一覧、ただし取得時にエラーが発生した場合はnull
     */
    $_showNewSentMessageList: async function () {
      // URL作成
      let url = RestApiClient.createApiUrl('send_message')
      let params = url.searchParams
      // 検索条件追加
      this.$_addSearchConditionCommon(params)
      // after
      // * クライアント側の送信からサーバーが処理するまでに時間がかかったメッセージが存在する可能性もあるため、
      //   送信済みメッセージ一覧取得の基準日時より少し前から取得するようにする
      const afterDate = moment(this.sentMessageBaseDate).subtract(1, 'second')
      params.append(
        'after',
        toServerTz(+afterDate, DATETIME_FORMAT_MILLISECOND)
      )

      try {
        const json = await RestApiClient.executeGetApi(url)
        const newMessages = json.data.map((d) => ({
          ...d,
          send_at: toLocalTz(d.send_at, DATETIME_FORMAT_MILLISECOND),
        }))
        // 一覧に追加する
        // 存在しない場合のみ追加する
        newMessages.forEach((newMessage) => {
          let findIndex = this.sentMessages.findIndex(
            (sentMessage) => sentMessage.id === newMessage.id
          )
          if (findIndex < 0) {
            // 存在しない場合はリストの先頭に追加する
            this.sentMessages.unshift(newMessage)
          } else {
            // 存在する場合は更新する
            this.sentMessages.splice(findIndex, 1, newMessage)
          }
        })
      } catch (error) {
        this.handleApiError(error)
      }
    },

    /**
     * 受信メッセージ検索用にURLSearchParamsに検索パラメータを追加する(limit, offsetは含まない)
     * @param {URLSearchParams} params パラメータを追加するURLSearchParams
     */
    $_addSearchConditionForReceived: function (params) {
      // 送信メッセージ検索と共通のパラメーター
      this.$_addSearchConditionCommon(params)

      // 送信ユーザーID
      if (this.currentSendUserIds.length > 0) {
        params.append('send_user_id', this.currentSendUserIds)
      }
    },

    /**
     * URLSearchParamsに検索パラメータを追加する(limit, offsetは含まない)
     * @param {URLSearchParams} params パラメータを追加するURLSearchParams
     */
    $_addSearchConditionCommon: function (params) {
      // キーワード
      if (this.searchKeyword) {
        // 半角スペース区切りでor検索ができるため、全角スペースを半角スペースに置き換える
        let keyword = this.searchKeyword.replace(/　/g, ' ')
        params.append('keyword', keyword)
      }
    },

    /**
     * 受信メッセージ一覧の対象の受信メッセージを既読にする
     * @param {number} 既読にする受信メッセージID
     */
    $_markMessageAsRead: function (messageId) {
      // 受信メッセージ一覧に含まれるメッセージも既読に設定する
      this.receivedMessages.find((value) => value.id === messageId).read_flg =
        true
    },

    /**
     * メッセージを受信メッセージ一覧の末尾に追加する。
     * ただし、既に存在している場合は既存のメッセージを更新する。
     * @param {Array} newMessages 追加対象のメッセージ
     */
    $_addReceivedMessages: function (newMessages) {
      newMessages.forEach((newMessage) => {
        let findIndex = this.receivedMessages.findIndex(
          (receiveMessage) => receiveMessage.id === newMessage.id
        )
        if (findIndex < 0) {
          // 存在しない場合はリストの末尾に追加する
          this.receivedMessages.push(newMessage)
        } else {
          // 存在する場合は更新する
          this.receivedMessages.splice(findIndex, 1, newMessage)
        }
      })
    },

    /**
     * メッセージ種別を変更する
     * @param {string} messageType 変更後のメッセージ種別
     */
    $_setMessageType: async function (messageType) {
      // 選択したメッセージ種別のメッセージ一を表示する
      this.currentMessageType = messageType

      if (messageType === MESSAGE_TYPES.RECEIVE) {
        // 受信メッセージの場合
        await this.$_searchMessageList()

        // 1件以上取得できている場合は最新メッセージの詳細を表示する
        if (this.receivedMessages.length > 0) {
          this.$_showReceivedMessageDetail(this.receivedMessages[0].id)
        }

        // 受信メッセージ変更した場合は、定期的に新着メッセージを確認する
        this.$_startCheckNewReceivedMessages()
      } else if (messageType === MESSAGE_TYPES.SEND) {
        // 送信メッセージの場合
        await this.$_searchMessageList()

        // 1件以上取得できている場合は最新メッセージの詳細を表示する
        if (this.sentMessages.length > 0) {
          this.$_showSentMessageDetail(this.sentMessages[0].id)
        }

        // 受信メッセージの定期チェックを停止する
        this.$_stopCheckNewReceivedMessages()
      } else {
        this.$log.error(`Unsupported message type.(type=${messageType}`)
      }
    },

    /**
     * 新着受信メッセージの定期的なチェックを開始する
     */
    $_startCheckNewReceivedMessages: function () {
      if (!this.checkIntervalId) {
        this.checkIntervalId = setInterval(
          this.$_updateReceivedMessages,
          this.interval
        )
      }
    },

    /**
     * 新着受信メッセージの定期的なチェックを停止する
     */
    $_stopCheckNewReceivedMessages: function () {
      if (this.checkIntervalId) {
        clearInterval(this.checkIntervalId)
        this.checkIntervalId = null
      }
    },

    /**
     * 指定し受信メッセージの詳細を表示する
     * @param {number} messageId メッセージID
     */
    $_showReceivedMessageDetail(messageId) {
      this.$refs['receive-message-detail'].show(messageId)

      // 一覧のメッセージを既読にする(少し時間が経ってから処理を実行する)
      setTimeout(this.$_markMessageAsRead, 500, messageId)
    },

    /**
     * 指定した送信済みメッセージの詳細を表示する
     * @param {number} messageId メッセージID
     */
    $_showSentMessageDetail(messageId) {
      this.$refs['send-message-detail'].show(messageId)
    },

    /**
     * 受信メッセージカードをクリックしたときの処理
     * @param {number} typeLineType タイムラインタイプ
     * @param {number} messageId メッセージID
     */
    $_onClickMessageCardReceive: function (typeLineType, messageId) {
      this.$_showReceivedMessageDetail(messageId)
    },

    /**
     * 送信メッセージカードをクリックしたときの処理
     * @param {number} typeLineType タイムラインタイプ
     * @param {number} messageId メッセージID
     */
    $_onClickMessageCardSend: function (typeLineType, messageId) {
      this.$_showSentMessageDetail(messageId)
    },

    /**
     * 受信メッセージ更新ボタンをクリックしたときの処理
     * @param {Boolean} [loading=false] ローディングを表示するか？
     */
    $_updateReceivedMessages: async function (loading = false) {
      if (loading) {
        this.$_showLoading()
      }
      // 最終更新日時
      // サーバーからの取得日時としたいが、dataのプロパティに設定すると取得完了前に日時が反映されてしまうため、
      // 一旦ローカル変数で保持
      const updateDate = new Date()

      // メッセージを取得する
      let newMessages
      let pastMessages
      try {
        ;[newMessages, pastMessages] = await Promise.all([
          this.$_getNewReceivedMessageList(),
          this.$_getPastReceivedMessageList(0, this.pastMessagesCount),
        ])
      } catch {
        this.$_hideLoading()
        return
      }

      // 新着メッセージをカウントする
      if (newMessages) {
        newMessages.forEach((newMessage) => {
          // 受信メッセージ一覧に存在しないメッセージが新着メッセージ
          if (
            !this.receivedMessages.find(
              (receivedMessage) => receivedMessage.id === newMessage.id
            )
          ) {
            this.newMessageCount++
          }
        })
      }

      // 更新する
      this.receivedMessages = []
      this.$_addReceivedMessages(newMessages)
      this.$_addReceivedMessages(pastMessages)
      this.receivedMessageUpdateDate = updateDate
      this.$_hideLoading()
    },

    /**
     * ユーザー選択コンポーネントで検索対象の送信ユーザーが確定した時の処理
     * @param {Object[]} value 選択されたユーザー情報のリスト
     */
    $_onSelectedSendUsers: function (value) {
      this.sendUserValue = value
      this.$_searchMessageList()
    },

    /**
     * ユーザー選択コンポーネントで検索対象の受信ユーザーが確定した時の処理
     * @param {Object[]} value 選択されたユーザー情報のリスト
     */
    $_onSelectedReceivedUsers: function (value) {
      this.receivedUserValue = value
      this.$_searchMessageList()
    },

    /**
     * キーワード検索実行時処理
     * @param {String} value キーワード
     */
    $_onSearchKeyword: function (value) {
      this.searchKeyword = value
      this.isKeywordChanged && this.$_searchMessageList()
    },

    /**
     * 新着メッセージボタンをクリックした時の処理
     */
    $_onClickNewMessage: function () {
      // 新規メッセージのカウントをリセットする
      this.newMessageCount = 0

      // 最新のメッセージのメッセージ詳細を表示する
      this.$_showReceivedMessageDetail(this.receivedMessages[0].id)
    },

    /**
     * メッセージ種別ボタンをクリックした時の処理
     * @param {string} messageType クリックしたボタンのメッセージ種別
     */
    $_onClickMessageType: function (messageType) {
      // メッセージ種別に変更がない場合は何もしない
      if (messageType === this.currentMessageType) {
        return
      }
      this.$_setMessageType(messageType)
    },

    /**
     * メッセージ新規送信ダイアログを表示する
     */
    $_showMessagePost: function () {
      this.$refs['message-post-dialog'].showModal()
    },

    /**
     * 新規メッセージを送信した時の処理
     */
    $_onSendNewMessage: function () {
      // 送信メッセージ一覧を表示している場合は、再度取得する
      if (this.currentMessageType === MESSAGE_TYPES.SEND) {
        this.$_showNewSentMessageList()
      }
    },

    /**
     * ローディングを表示する
     */
    $_showLoading: function () {
      this.isLoading = true
    },

    /**
     * ローディングを非表示にする
     */
    $_hideLoading: function () {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../assets/scss/parts/container';
@use '../assets/scss/parts/tool-bar';
@use '../assets/scss/parts/title-bar';

$-header-title-height: 20px;
$-header-padding-vertical: 15.5px;
$-header-border-width: 1px;
$-header-height: calc(
  #{$-header-title-height} + 2 * #{$-header-padding-vertical} +
    #{$-header-border-width}
);
$-message-nav-width: 200px;
$-list-header-height: 52px;

#the-message {
  width: 100%;
  height: 100%;
}

.container-message {
  ::v-deep .row {
    margin: 0;
  }
}

.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: calc(100% - #{$tool-bar-height});
  margin-right: 0;
}

.view-list {
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #ffffff;
  transition: 0.3s;
}

.view-detail {
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #ffffff;
  transition: 0.3s;
}

.content-navbar {
  display: flex;
  align-items: flex-end;
}

.message-nav {
  width: $-message-nav-width;
  padding: 5px 5px 5px 5px;

  button {
    font-size: 0.9em;
  }

  > .btn-group {
    button.active {
      color: #ffffff;
      background-color: #27a745;
      border-color: #27a745;
    }
  }
}

.tool-bar {
  width: calc(100% - #{$-message-nav-width});
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tool-bar-form {
  width: 100%;
}

.title-bar {
  padding: 0 10px 0 20px;

  h1 {
    font-size: $font-size-middle;
    letter-spacing: 0;
  }
}

.title-bar-action {
  column-gap: 8px;
}

.button-create {
  @include mixin-button;
  & {
    height: $button-size;
    column-gap: 4px;
    padding: 0 8px;
    font-size: $font-size-small;
  }
}

.list-wrapper {
  height: calc(100% - #{$tool-bar-height});
  flex-grow: 1;
  flex-basis: 0;
  margin: 0;
  padding: 0 10px 10px 10px;
}

.list-header {
  height: $-list-header-height;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.list-inner {
  padding-top: 5px;
  overflow-y: scroll;
  @include mixin-scrollbar;

  &.list-inner-send {
    height: 100%;
  }

  &.list-inner-receive {
    height: calc(100% - #{$-list-header-height});
  }
}

.list-tail {
  padding: 0 0 5px 0;
}

.message-detail-body {
  padding: 0 10px 10px 0;
  height: 100%;
}

.box-inner-message-detail {
  height: 100%;
  overflow-y: auto;
  @include mixin-scrollbar;
}

.message-detail-user {
  padding: 5px 10px;
  border-bottom: 1px solid #e0e0e0;
}

.message-detail-user-list {
  div:last-of-type {
    border-bottom: none;
  }
}

.message-body {
  background-color: #f6f6f6;
  padding: 20px 20px;
  text-align: left;
}

.event-card {
  margin: 0 0 20px 0;
}
</style>
